// extracted by mini-css-extract-plugin
export var date = "blog-post-preview-module--date--gkn80";
export var excerpt = "blog-post-preview-module--excerpt--BptUh";
export var inGrid = "blog-post-preview-module--inGrid--Su0dq blog-post-preview-module--root--lZOsH";
export var inList = "blog-post-preview-module--inList--V0-4d blog-post-preview-module--root--lZOsH";
export var leadMediaThumb = "blog-post-preview-module--leadMediaThumb--NuRQ-";
export var root = "blog-post-preview-module--root--lZOsH";
export var text = "blog-post-preview-module--text---oxZQ";
export var title = "blog-post-preview-module--title--QUliB";